import(/* webpackMode: "eager" */ "/Users/gary.craine/code/city-chat/client/src/app/page.tsx");
